import {httpAuth} from './config';

export default {
    pending: () => {
        return httpAuth.get('api/external/notification/pending');
    },
    accept: (id) => {
        return httpAuth.post(`api/external/notification/${id}/accept`);
    },
};
